<app-daily-charger-usage-report></app-daily-charger-usage-report>
<app-monthly-quarterly-charger-usage-report></app-monthly-quarterly-charger-usage-report>
<app-monthly-quarterly-charger-usage-charts></app-monthly-quarterly-charger-usage-charts>
<app-power-usage-charts
	[hasTruckTypesFilter]="false"
	[deviceTypes]="chargerTypes"
	[config]="powerUsageChartConfig"
	[tooltipText]="'chargLinkDevice.site_power_usage_chart'"
></app-power-usage-charts>

<!--! these two charts shifted to other task -->
<!-- <app-daily-hourly-charger-usage-data></app-daily-hourly-charger-usage-data> -->
